export enum ProjectionCategoryEnum {
  salesAmount = 'sales_amount',
  addedValue = 'added_value',
  brutExploitationProfit = 'brut_exploitation_profit',
  brutMargin = 'brut_margin',
  currentResult = 'current_result',
  netResult = 'net_result'
}
